import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Crown, User } from "lucide-react";

import ConditionsVisibiliteModals from "../components/ConditionsVisibiliteModals";
import ProsMarquee from "./blog/ProsMarquee";
import PremiumCountBanner from "../components/PremiumCountBanner";

// Contenu Bleu/Sable - Pour la page "Professionnels"  
const ContenuBleuSable = () => {
  const [showVisibiliteModal, setShowVisibiliteModal] = useState(false);
  const [showOrdreModal, setShowOrdreModal] = useState(false);
  const [showInscriptionConditionsModal, setShowInscriptionConditionsModal] = useState(false);
  const [showPremiumConditionsModal, setShowPremiumConditionsModal] = useState(false);
  const [showRotationModal, setShowRotationModal] = useState(false);
  return (
    <div className="min-h-screen bg-gray-50" data-testid="professionnels-page">
      {/* Styles pour le header Noir/Bleu/Sable */}
      <style>{`
        /* Animation illumination boutons Sa fiche / Son site */
        @keyframes btn-glow-fiche-pro {
          0% {
            box-shadow: 0 0 30px rgba(58, 110, 165, 1), 0 0 60px rgba(58, 110, 165, 0.6), 0 0 90px rgba(58, 110, 165, 0.3);
            transform: scale(1.1);
          }
          50% {
            box-shadow: none;
            transform: scale(1);
          }
          100% {
            box-shadow: none;
            transform: scale(1);
          }
        }
        
        @keyframes btn-glow-site-pro {
          0% {
            box-shadow: none;
            transform: scale(1);
          }
          50% {
            box-shadow: 0 0 30px rgba(58, 110, 165, 1), 0 0 60px rgba(58, 110, 165, 0.6), 0 0 90px rgba(58, 110, 165, 0.3);
            transform: scale(1.1);
          }
          100% {
            box-shadow: none;
            transform: scale(1);
          }
        }

        /* HEADER — Noir/Bleu/Sable pour Professionnels */
        .hero-header-pro {
          background: linear-gradient(180deg, 
            #000000 0%,
            #0a0a1a 15%,
            #0d1b2a 30%,
            #1b3a5f 50%,
            #3a6ea5 65%,
            #7eb8da 78%,
            #D4C4A8 90%,
            #F5F0E8 100%
          );
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          padding: 2rem;
          padding-bottom: 15vh;
          position: relative;
          overflow: hidden;
        }

        /* Effet de lumière subtile bleutée */
        .hero-header-pro::before {
          content: '';
          position: absolute;
          top: 60%;
          left: 50%;
          transform: translateX(-50%);
          width: 200%;
          height: 100%;
          background: radial-gradient(ellipse at center, 
            rgba(126, 184, 218, 0.3) 0%, 
            transparent 70%
          );
          pointer-events: none;
        }

        /* Transition vers le bandeau sable */
        .hero-header-pro::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 100px;
          background: linear-gradient(to bottom, 
            transparent 0%, 
            #FDF8F3 100%
          );
          pointer-events: none;
        }

        .hero-title-pro {
          font-size: clamp(2.5rem, 6vw, 4.5rem);
          font-weight: 700;
          color: #FFFBEB;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
          margin-bottom: 1rem;
          line-height: 1.2;
          position: relative;
          z-index: 1;
        }

        .hero-subtitle-pro {
          font-size: clamp(1.1rem, 2.5vw, 1.5rem);
          color: #bde0fe;
          font-weight: 400;
          max-width: 600px;
          text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
          position: relative;
          z-index: 1;
        }

        .hero-badge-pro {
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: #FFFBEB;
          padding: 0.5rem 1.5rem;
          border-radius: 50px;
          font-size: 0.9rem;
          margin-top: 2rem;
          position: relative;
          z-index: 1;
        }

        /* Welcome section - Sable lumineux */
        .welcome-section-pro {
          background: #F5F0E8;
          padding: 5rem 2rem;
          text-align: center;
          position: relative;
        }

        .welcome-section-pro::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, 
            transparent 0%, 
            #3a6ea5 50%, 
            transparent 100%
          );
        }

        .welcome-title-pro {
          font-size: clamp(1.5rem, 4vw, 2.5rem);
          font-weight: 700;
          color: #1b3a5f;
          margin-bottom: 2rem;
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        .welcome-text-pro {
          font-size: clamp(1rem, 2vw, 1.25rem);
          color: #3a6ea5;
          line-height: 1.8;
          max-width: 800px;
          margin: 0 auto;
        }

        .welcome-text-pro strong {
          color: #1b3a5f;
          font-weight: 600;
        }
        
        @keyframes float-icon-pro {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          25% { transform: translateY(-8px) rotate(-5deg); }
          50% { transform: translateY(-4px) rotate(0deg); }
          75% { transform: translateY(-10px) rotate(5deg); }
        }
        @keyframes sparkle-pro {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(0.8); }
        }
        .icon-float-pro {
          animation: float-icon-pro 3s ease-in-out infinite;
          display: inline-block;
        }
        .icon-float-delay-pro {
          animation: float-icon-pro 3s ease-in-out infinite;
          animation-delay: 0.5s;
          display: inline-block;
        }
        .sparkle-anim-pro {
          animation: sparkle-pro 1.5s ease-in-out infinite;
        }

        /* Mobile : réduction de l'espace dans le hero */
        @media (max-width: 1023px) {
          .hero-header-pro {
            min-height: auto;
            padding: 1rem 1.5rem;
            padding-bottom: 4rem;
            padding-top: 6rem;
          }
          .hero-header-pro::after {
            height: 50px;
          }
          .hero-badge-pro {
            margin-top: 1rem;
          }
          .hero-title-pro {
            margin-bottom: 0.5rem;
          }
          /* Mobile : appliquer la couleur bleu foncé au texte "N°1 en France..." */
          .hero-badge-n1-text {
            color: #1e3a8a;
            -webkit-text-fill-color: #1e3a8a;
          }
        }
      `}</style>

      {/* Hero Section - Noir/Bleu/Sable */}
      <section className="hero-header-pro">
        <div className="hero-badge-pro" style={{ marginBottom: '2rem' }}>
          <span style={{ display: 'inline-block', width: '8px', height: '8px', backgroundColor: '#4ade80', borderRadius: '50%', marginRight: '8px', animation: 'pulse 2s infinite' }}></span>
          Inscription 100% gratuite • Sans engagement
        </div>
        <h1 className="hero-title-pro">
          Rejoignez nous
          <br/>
          {/* Mobile : espacement supplémentaire */}
          <span className="lg:hidden" style={{ display: 'block', height: '0.8rem' }}></span>
          Faites rayonner votre savoir-faire
        </h1>
        <div className="hero-badge-pro" style={{ fontWeight: 'bold' }}>
          <span style={{ display: 'inline-block', width: '8px', height: '8px', backgroundColor: '#4ade80', borderRadius: '50%', marginRight: '8px', animation: 'pulse 2s infinite' }}></span>
          <span className="hero-badge-n1-text">N°1 en France • Visibilité locale et nationale</span>
        </div>

        {/* Compteur preuve sociale + Défilé des professionnels Premium */}
        <div className="hero-premium-block" data-testid="nous-rejoindre-pros-marquee">
          <PremiumCountBanner cat="all" />
          <ProsMarquee cat="all" />
        </div>
      </section>

      {/* Bandeau 2 (ON VOUS PROPOSE / bouton GRATUIT) — SUPPRIMÉ
          (fermeture commerciale des nouvelles inscriptions gratuites,
           PRD 2026-02-XX). Les professionnels gratuits déjà enregistrés
           restent inchangés et continuent d'apparaître normalement. */}

      {/* Bandeau "Conditions de visibilité + Rotation équitable" — entre carte Gratuite et bandeau Premium */}
      <div className="conditions-banner-pro conditions-banner-pro-light" data-testid="bleusable-conditions-banner">
        <div className="conditions-banner-group">
          <span className="conditions-banner-label">Conditions de visibilité</span>
          <div className="conditions-banner-row">
            <button
              type="button"
              onClick={() => setShowInscriptionConditionsModal(true)}
              className="conditions-banner-btn"
              data-testid="bleusable-banner-conditions-gratuit"
              aria-label="Voir les conditions de visibilité — inscription gratuite"
            >
              Gratuit
            </button>
            <button
              type="button"
              onClick={() => setShowPremiumConditionsModal(true)}
              className="conditions-banner-btn"
              data-testid="bleusable-banner-conditions-premium"
              aria-label="Voir les conditions de visibilité — formule Premium"
            >
              Premium
            </button>
          </div>
        </div>

        <div className="conditions-banner-separator" aria-hidden="true" />

        <div className="conditions-banner-group">
          <span className="conditions-banner-label">En savoir plus</span>
          <div className="conditions-banner-row">
            <button
              type="button"
              onClick={() => setShowRotationModal(true)}
              className="conditions-banner-btn"
              data-testid="bleusable-banner-rotation-equitable"
              aria-label="Découvrir notre principe de rotation équitable des annonces"
            >
              Rotation équitable des annonces
            </button>
            <button
              type="button"
              onClick={() => setShowOrdreModal(true)}
              className="conditions-banner-btn"
              data-testid="bleusable-banner-ordre-visibilite"
              aria-label="Voir l'ordre de visibilité des annonces"
            >
              Ordre de visibilité des annonces
            </button>
            <button
              type="button"
              onClick={() => setShowVisibiliteModal(true)}
              className="conditions-banner-btn"
              data-testid="bleusable-banner-ou-visible"
              aria-label="Voir où votre annonce sera visible"
            >
              Où votre annonce sera visible&nbsp;?
            </button>
          </div>
        </div>
      </div>

      {/* Bandeau 3 : OFFRE PREMIUM - Bleu nuit profond */}
      <section className="py-12" style={{ backgroundColor: '#0F172A' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl p-8 text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl cursor-pointer" style={{ backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(251, 191, 36, 0.3)' }}>
            {/* Logo avec dégradé jaune-orange */}
            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center" style={{ background: 'linear-gradient(to right, #EAB308, #F97316)' }}>
              <Crown className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              ON VOUS PROPOSE<br className="mobile-only-br" /> UNE OFFRE PREMIUM
            </h3>
            <h4 className="text-xl font-bold mb-4" style={{ background: 'linear-gradient(to right, #EAB308, #F97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              QUI FAIT LA DIFFÉRENCE
            </h4>
            <p className="text-white text-lg leading-relaxed mb-6">
              Vous souhaitez plus de visibilité<br className="mobile-only-br" /> et plus de clients ?
            </p>
            <p className="text-white text-lg leading-relaxed mb-6">
              L'Offre Premium est conçue<br className="mobile-only-br" /> pour les professionnels<br/>
              qui veulent valoriser leur image<br className="mobile-only-br" /> et développer leurs revenus.
            </p>
            <div className="text-white text-left max-w-lg mx-auto space-y-5 mb-6">
              <div>
                <p className="font-bold text-lg" style={{ background: 'linear-gradient(to right, #EAB308, #F97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>⭐ 29 € TTC / an / département</p>
                <p className="pl-7 text-white/90 text-base">Un investissement maîtrisé pour une visibilité optimale</p>
              </div>
              <div>
                <p className="font-bold text-lg" style={{ background: 'linear-gradient(to right, #EAB308, #F97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>⭐ Tarifs dégressifs</p>
                <p className="pl-7 text-white/90 text-base">
                  Développez votre visibilité sur plusieurs départements,<br/>
                  ou bénéficiez d'une présence renforcée dans toute la France.
                </p>
                <p className="pl-7 text-white/90 text-base mt-2">
                  Plus votre couverture est étendue,<br/>
                  plus vos avantages deviennent attractifs.
                </p>
              </div>
              <div>
                <p className="font-bold text-lg" style={{ background: 'linear-gradient(to right, #EAB308, #F97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>⭐ 0 % de commission :</p>
                <p className="pl-7 text-white text-base">Chaque consultation vous appartient</p>
              </div>
              <div>
                <p className="font-bold text-lg" style={{ background: 'linear-gradient(to right, #EAB308, #F97316)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>⭐ 100 % de vos revenus conservés</p>
                <p className="pl-7 text-white text-base">Sans surprise ni frais cachés</p>
              </div>
            </div>
            <p className="text-white text-lg leading-relaxed font-medium">
              ✔️ Un modèle clair, transparent et efficace, pour garder le contrôle total de votre activité.
            </p>
          </div>
        </div>
      </section>

      {/* Section avec le bouton PREMIUM seul */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center">
            {/* BOUTON INSCRIPTION PREMIUM - Seul */}
            <Link 
              to="/inscription-premium" 
              className="block transition-transform duration-300 hover:-translate-y-2 max-w-md w-full"
              style={{ textDecoration: 'none' }}
            >
              <div className="relative flex flex-col">
                {/* Onglet PREMIUM */}
                <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-bold py-3 px-6 rounded-t-2xl text-center flex items-center justify-center gap-2">
                  <span className="text-xl">👑</span>
                  <span>PREMIUM</span>
                </div>
                
                {/* Carte principale */}
                <div className="bg-slate-900/90 backdrop-blur-lg border border-slate-700 rounded-b-2xl p-6 text-center transition-all duration-300 hover:border-yellow-500/50 flex-1 flex flex-col justify-between">
                  <div>
                    {/* Icône animée avec effet brillant */}
                    <div className="text-5xl mb-3 relative inline-block">
                      <span className="icon-float-delay-pro">💎</span>
                    </div>
                    
                    {/* Titre */}
                    <h3 className="text-2xl font-bold mb-1 text-white">Inscription Premium</h3>
                    <p className="text-yellow-400 mb-5 text-sm">Expérience exclusive</p>
                    
                    {/* Grille des fonctionnalités Premium */}
                    <div className="grid grid-cols-2 gap-2 mb-4">
                      <div className="bg-slate-800/80 rounded-lg py-2 px-3 flex items-center gap-2">
                        <span className="text-purple-400">⭐</span>
                        <span className="text-white/90 text-xs">Visibilité maximale</span>
                      </div>
                      <div className="bg-slate-800/80 rounded-lg py-2 px-3 flex items-center gap-2">
                        <span className="text-blue-400">📧</span>
                        <span className="text-white/90 text-xs">Email visible</span>
                      </div>
                      <div className="bg-slate-800/80 rounded-lg py-2 px-3 flex items-center gap-2">
                        <span className="text-green-400">📞</span>
                        <span className="text-white/90 text-xs">Téléphone affiché</span>
                      </div>
                      <div className="bg-slate-800/80 rounded-lg py-2 px-3 flex items-center gap-2">
                        <span className="text-cyan-400">🌐</span>
                        <span className="text-white/90 text-xs">Site web premium</span>
                      </div>
                      <div className="bg-slate-800/80 rounded-lg py-2 px-3 flex items-center gap-2">
                        <span className="text-pink-400">📷</span>
                        <span className="text-white/90 text-xs">Photo de profil</span>
                      </div>
                      <div className="bg-slate-800/80 rounded-lg py-2 px-3 flex items-center gap-2">
                        <span className="text-orange-400">📝</span>
                        <span className="text-white/90 text-xs">Description complète</span>
                      </div>
                    </div>
                    
                    {/* Prix */}
                    <div className="text-3xl font-bold text-yellow-400 mb-4">
                      <span className="block text-sm font-normal text-yellow-400/80 mb-1">À partir de</span>
                      29€<span className="text-lg text-yellow-400/70">/an</span>
                    </div>
                  </div>
                  
                  {/* Bouton d'action */}
                  <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-semibold py-3 px-6 rounded-xl hover:from-yellow-600 hover:to-orange-600 transition-all">
                    Devenir Premium →
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Bandeau 5 : CTA Final - Dégradé lever de soleil inversé */}
      <section className="py-16 relative" style={{ background: 'linear-gradient(180deg, #FBBF24 0%, #F59E0B 10%, #D97706 25%, #92400E 45%, #451A03 65%, #1C1917 85%, #000000 100%)' }}>
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4" style={{ textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>Prêt à développer<br className="mobile-only-br" /> votre activité ?</h2>
          <p className="text-amber-200 mb-8" style={{ textShadow: '0 1px 4px rgba(0, 0, 0, 0.3)' }}>Rejoignez les professionnels qui nous font confiance</p>
          <Link to="/vous-connecter" className="inline-block px-10 py-4 rounded-full font-bold text-lg transition shadow-lg hover:opacity-90 hover:-translate-y-1" style={{ backgroundColor: '#FBBF24', color: '#451A03', textDecoration: 'none', boxShadow: '0 4px 15px rgba(245, 158, 11, 0.4)' }}>
            Inscription Pro
          </Link>
        </div>
      </section>

      {/* Modales partagées "Conditions de visibilité" Gratuit + Premium + Rotation + Ordre + Où visible */}
      <ConditionsVisibiliteModals
        showInscription={showInscriptionConditionsModal}
        showPremium={showPremiumConditionsModal}
        showRotation={showRotationModal}
        showOrdre={showOrdreModal}
        showOuVisible={showVisibiliteModal}
        onCloseInscription={() => setShowInscriptionConditionsModal(false)}
        onClosePremium={() => setShowPremiumConditionsModal(false)}
        onCloseRotation={() => setShowRotationModal(false)}
        onCloseOrdre={() => setShowOrdreModal(false)}
        onCloseOuVisible={() => setShowVisibiliteModal(false)}
      />
    </div>
  );
};


export default ContenuBleuSable;
